module.exports = __webpack_public_path__ + "static/Wolf-db7b1b80960bc175dc827b7e76871773.jpg";